import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AgTechWebAppLoginHandler from '../Auth/Pages/AgTechWebAppLoginHandler'
import AgTechWebAppLoginPage from '../Auth/Pages/AgTechWebAppLoginPage'
import AgTechWebAppSurface from '../Templates/App/AgTechWebAppSurface'
import { useAgTechWebAppContext } from '../Contexts/AgTechWebAppContext'
import AgTechWebAppLoadingPage from '../Loading/AgTechWebAppLoadingPage'
import AgTechWebAppLanding from '../Landing/AgTechWebAppLanding'
import { AgTechWebApplication } from '../../../application/AgTechWebApplication'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import AgTechWebAppProtectedRoute from './AgTechWebAppProtectedRoute'

const AgTechWebAppRouter = (props: {
    app: AgTechWebApplication
}) => {
    const appNavigation = useAgTechWebAppContext().navigation;

    return (
        <Routes>
            <Route path='/*' element={<AgTechWebAppLanding app={props.app} />} />
            <Route path="/login" element={<AgTechWebAppLoginPage app={props.app} />} />
            <Route path='/auth/login' element={<AgTechWebAppLoginHandler />} />
            <Route path="/app" element={<Navigate to="/app/home" replace />} />
            <Route
                path='/app/*'
                element={(
                    <AgTechWebAppProtectedRoute>
                        <>
                            <AgTechWebAppLoadingPage app={props.app}>
                                <AgTechWebAppSurface 
                                    app={props.app}
                                    path={appNavigation.currentRoute}
                                />
                            </AgTechWebAppLoadingPage>
                            <ReactQueryDevtools initialIsOpen={false} />
                        </>
                    </AgTechWebAppProtectedRoute>
                )}
            />
        </Routes>
    )
}

export default React.memo(AgTechWebAppRouter);